import axios from 'axios';
import { getApiHeaders } from '../../../utils/apiHelpers';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/gestione/haccp/olio-esausto`;

export const oliApi = {
  get: (path, opts = {}) => axios.get(`${BASE}${path}`, { headers: getApiHeaders(), ...opts }).then((r) => r.data),
  post: (path, body) => axios.post(`${BASE}${path}`, body, { headers: getApiHeaders() }).then((r) => r.data),
  put: (path, body) => axios.put(`${BASE}${path}`, body, { headers: getApiHeaders() }).then((r) => r.data),
  del: (path) => axios.delete(`${BASE}${path}`, { headers: getApiHeaders() }).then((r) => r.data),
};

export const erroreOli = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  return Array.isArray(d) ? 'Controlla i dati inseriti' : fallback;
};

export const dataIt = (s) => (s ? s.slice(0, 10).split('-').reverse().join('/') : '-');
export const oggiIso = () => new Date().toLocaleDateString('sv-SE');
export const adessoLocale = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16);

export const scaricaFascicolo = async (anno) => {
  const blob = await oliApi.get(`/fascicolo?anno=${anno}`, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  const a = Object.assign(document.createElement('a'), { href: url, download: `Registro_Oli_Esausti_${anno}.pdf` });
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const urlDocumento = (prelievoId, tipo) => {
  const tenant = getApiHeaders()['X-Tenant-DB'] || '';
  const percorso = tipo === 'copia' ? 'copia-ritorno/documento' : 'documento';
  return `${BASE}/prelievi/${prelievoId}/${percorso}?X-Tenant-DB=${encodeURIComponent(tenant)}`;
};

// Stesse soglie del backend: composti polari 25% (Circ. Min. Sanità 1/1991), frittura entro 180 °C
export const esitoOlio = ({ metodo, polari, visivo, temperatura }) => {
  let esito;
  if (metodo === 'tester') {
    if (polari === '' || polari == null) return null;
    const p = Number(polari);
    if (p >= 25) return 'non_conforme';
    esito = p >= 20 ? 'attenzione' : 'conforme';
  } else {
    if (visivo.fumo || visivo.schiuma || visivo.odore_acre) return 'non_conforme';
    esito = visivo.colore === 'scuro' ? 'attenzione' : 'conforme';
  }
  return esito === 'conforme' && Number(temperatura) > 180 ? 'attenzione' : esito;
};
